import axios from 'axios';
import { getAdminsQuery } from './queries';
import { resolveId } from '../../utils';

const getAdminListDetails = (includeDeleted, filterSubUsers = true) =>
    new Promise((resolve, reject) => {
        const fields = ['id', 'name', 'created_at', 'updated_at', 'username', 'email', 'secondary_email', 'deleted_at', 'permissions', 'role_category', 'equity_approval'];
        const params = { fields, includeDeleted, filterSubUsers };
        const query = getAdminsQuery(params);
        const request = axios.get(query);

        request
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data.filter(Boolean) : [];
                resolve({ admins: data.map(resolveId) });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getAdminListDetails;
